import { useTheme } from '@mui/material';
import CrossBorderPaymentsIcon from '../../../public/svg/icons/stellar/payment-and-remittance.svg';
import TokenIssuanceIcon from '../../../public/svg/icons/stellar/tokenization-platforms.svg';
import SorobanIcon from '../../../public/svg/icons/stellar/defi-platforms.svg';
import EnterpriseBlockchainIcon from '../../../public/svg/icons/stellar/enterprise-blockchain-solutions.svg';

export const StellarProductDevelopmentServicesData = {
  mainText: 'Stellar development made to measure',
  description: `Rumble Fish builds Stellar and Soroban software for fintech startups, enterprises, and institutions. We develop payment rails, tokenization platforms, smart contracts, and DeFi applications that draw on Stellar's speed, low costs, and financial infrastructure. Whether you're moving money across borders, issuing assets, or building on-chain finance products, we turn your specification into production-ready code. We also know the network from the inside: we've shipped infrastructure for the Stellar ecosystem under two Stellar Community Fund grants.`,
};

export const AccordionData = () => {
  const theme = useTheme();
  return [
    {
      iconSvg: CrossBorderPaymentsIcon,
      iconSvgAlt: 'cross-border-payments-icon',
      title: 'Payment & Remittance Solutions',
      description: `
      Cross-border payments shouldn't take three business days or cost $40 per wire. Stellar was built for this, and we build on-chain payment systems that settle in seconds.
      <ul>
        <li>Cross-border payment and remittance platforms</li>
        <li>Anchor integrations connecting fiat on/off ramps (SEP-24, SEP-31)</li>
        <li>Multi-currency and stablecoin settlement systems (including native USDC)</li>
        <li>Automated treasury and payout tooling</li>
      </ul>
    `,
      gradientOnFocus: theme.mixins.yellowGradient?.background as string,
    },
    {
      iconSvg: TokenIssuanceIcon,
      iconSvgAlt: 'tokenization-asset-issuance-icon',
      title: 'Tokenization & Asset Issuance',
      description: `
      Stellar has been an asset-issuance network since day one, and Soroban adds programmable, standardized tokens on top of it. Bring your tokenization product to market with a team that knows both the classic and the Soroban side.
      <ul>
        <li>Real-world asset (RWA) tokenization platforms</li>
        <li>Stablecoin issuance and management systems</li>
        <li>SEP-41 Soroban token contracts and classic Stellar assets</li>
        <li>Compliant token frameworks with built-in authorization and clawback controls</li>
      </ul>
    `,
      gradientOnFocus: theme.mixins.yellowGradient?.background as string,
    },
    {
      iconSvg: SorobanIcon,
      iconSvgAlt: 'soroban-smart-contracts-defi-icon',
      title: 'Soroban Smart Contracts & DeFi',
      description: `
      Soroban is Stellar's smart contract platform. It's written in Rust, uses resource metering for predictable fees, and is built for financial use cases. Much of the most active development on Stellar is happening here.
      <ul>
        <li>Soroban smart contract design, development, and auditing</li>
        <li>Decentralized exchange and AMM interfaces</li>
        <li>Liquidity pool and yield management systems</li>
        <li>Price-sensitive DeFi protocols built on reliable data infrastructure</li>
      </ul>
    `,
      gradientOnFocus: theme.mixins.yellowGradient?.background as string,
    },
    {
      iconSvg: EnterpriseBlockchainIcon,
      iconSvgAlt: 'enterprise-infrastructure-solutions-icon',
      title: 'Enterprise & Infrastructure Solutions',
      description: `
      Institutions don't want to move fast and break things. They want reliability, compliance, and performance. Stellar has been live since 2015, with an established anchor network and native compliance primitives, and we build institutional-grade systems on top of it.
      <ul>
        <li>Anchor infrastructure with KYC/AML and SEP-10 authentication workflows</li>
        <li>Enterprise tokenization frameworks for securities, stablecoins, and structured products</li>
        <li>High-availability Horizon and Soroban RPC node infrastructure</li>
        <li>Custom indexing, data, and analytics pipelines</li>
        <li>Seamless integration with legacy banking systems and payment rails</li>
        <li>White-label solutions for banks, fintechs, and asset managers</li>
      </ul>
    `,
      gradientOnFocus: theme.mixins.yellowGradient?.background as string,
    },
  ];
};
